var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu-container",class:{ open: _vm.opened },on:{"mouseenter":_vm.showMenu,"mouseleave":_vm.leaveMenu}})}
var staticRenderFns = []

export { render, staticRenderFns }